// extracted by mini-css-extract-plugin
module.exports = {"root":"CustomTip_root__3oKtc","inputWrap":"CustomTip_inputWrap__1ugnI"};